import { LocalizationLanguage } from '@gov-nx/core/app';
import { useUserStoreLanguage } from '@gov-nx/store';

interface AppLanguageSelector {
	language: LocalizationLanguage;
}

export const useAppLanguageSelector = (): AppLanguageSelector => {
	const language = useUserStoreLanguage();

	return { language: language ?? LocalizationLanguage.Czech };
};
